import React from 'react';

import phoneFormat from '../../util/phoneformat.js';

let PhoneNumber = ({children}) => {
  return (
    <span>{phoneFormat(children)}</span>
  );
};

export default PhoneNumber;
